import { StyleProp } from "./StyleProp.mjs";
const DefaultFillStyle = StyleProp.defineEnum("tldraw:fill", {
  defaultValue: "none",
  values: ["none", "semi", "solid", "pattern", "fill", "lined-fill"]
});
export {
  DefaultFillStyle
};
//# sourceMappingURL=TLFillStyle.mjs.map
